import { render } from "./AddedServices.vue?vue&type=template&id=666b434c&scoped=true"
import script from "./AddedServices.vue?vue&type=script&lang=js"
export * from "./AddedServices.vue?vue&type=script&lang=js"

import "./AddedServices.vue?vue&type=style&index=0&id=666b434c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666b434c"]])

export default __exports__